// extracted by mini-css-extract-plugin
export default {"kycGridContainer":"KycData_kycGridContainer__TO5cN","infoGrid":"KycData_infoGrid__bNMKJ","noDataMessage":"KycData_noDataMessage__9So6o"};